import { Component, EventEmitter, Input, Output } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { RadioOption } from "@/components/shared/radio-list/radio-list.component";
import { getDateRangeForTimeFrame } from "@/_utility/date.utils";
import { GroupFilterOptions } from "@/_models/filters/group-filter-options";

@Component({
    selector: "app-risk-insights-filter-sidebar",
    templateUrl: "./risk-insights-filter-sidebar.component.html",
    styleUrls: ["./risk-insights-filter-sidebar.component.scss"],
})
export class RiskInsightsFilterSidebarComponent {
    @Input() filterForm: UntypedFormGroup;
    @Input() timeFrameList: RadioOption[];
    @Input() userList: RadioOption[];
    @Input() showGroupFilters = false;
    @Input() groupFilterOptions: GroupFilterOptions;
    @Output() closeButtonClicked: EventEmitter<void> = new EventEmitter<void>();

    showDateRangeFilterModal = false;
    dateRangeFilterControl: UntypedFormControl;
    private dateRangeTimeFrameControl: UntypedFormControl;

    close() {
        this.closeButtonClicked.emit();
    }

    setDateRangeValue(control: UntypedFormControl, value: any) {
        control.setValue(value);
        if (value === "") {
            return this.filterForm.get("createdAt").setValue("");
        }
        if (value === "custom") {
            this.dateRangeTimeFrameControl = control;
            this.dateRangeFilterControl = this.filterForm.get(
                "createdAt",
            ) as UntypedFormControl;
            this.showDateRangeFilterModal = true;
            return;
        }
        const range = getDateRangeForTimeFrame(value);
        if (range) {
            return this.filterForm.get("createdAt").setValue(range);
        }
    }

    onDateRangeFilterModalVisibleChange(visible: boolean) {
        this.showDateRangeFilterModal = visible;
        if (
            !visible &&
            !this.filterForm.get("createdAt").value?.length &&
            this.dateRangeTimeFrameControl
        ) {
            this.setDateRangeValue(this.dateRangeTimeFrameControl, "");
        }
    }
}
